/**
 * Returns a CommonJS module's real default export when a bundler's ESM interop
 * surfaces the module namespace (`{ default }`) instead of the export itself.
 */
export function interopDefault<T>(maybeWrapped: T): T {
  return (maybeWrapped as { default?: T }).default ?? maybeWrapped;
}

export default interopDefault;
